module.exports = __webpack_public_path__ + "img/Flaticon.500d63cc.svg";